module.exports = __webpack_public_path__ + "static/media/cafe.44eddec4.svg";